import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type {
	CreateSnippetArgs,
	DeleteSnippetArgs,
	UpdateSnippetArgs,
} from "../types"

export const snippetMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateSnippetArgs
			ctx: ZeroJwtPayload
		}) => {
			// Check if snippet already exists
			const [existingSnippet] = await tx.query.snippets
				.where("id", "=", args.id)
				.run()

			if (existingSnippet) {
				throw new Error("Snippet already exists")
			}

			await tx.mutate.snippets.insert({
				id: args.id,
				title: args.title,
				html: args.html,
				emailId: args.emailId,
				folderId: args.folderId,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				isDeleted: false,
				version: 1,
				workspaceId: authData.workspaceId,
			})
		},
	),
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateSnippetArgs }) => {
			await tx.mutate.snippets.update(args)
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteSnippetArgs }) => {
			// Hard delete - remove from database
			await tx.mutate.snippets.delete({ id: args.id })
		},
	),
}
